import type { ChangeEvent, Ref } from 'react'
import { Button } from '@/shared/components'

type LicenseUploadFieldProps = {
  inputRef: Ref<HTMLInputElement>
  isUploading: boolean
  uploadError: string | null
  uploadedLicenseFileName: string
  onUploadClick: () => void
  onFileChange: (event: ChangeEvent<HTMLInputElement>) => void
}

export function LicenseUploadField({
  inputRef,
  isUploading,
  uploadError,
  uploadedLicenseFileName,
  onUploadClick,
  onFileChange
}: LicenseUploadFieldProps) {
  return (
    <div className="animate-fade-in-up" style={{ animationDelay: '400ms' }}>
      <label className="enrollment-field-label">Upload front of drivers license</label>

      <Button
        type="button"
        variant="secondary"
        onClick={onUploadClick}
        disabled={isUploading}
        fullWidth
        className="!h-10 !text-sm hover:-translate-y-0.5 active:scale-95"
      >
        {isUploading ? 'Uploading...' : 'Upload'}
      </Button>
      <input
        ref={inputRef}
        type="file"
        accept=".jpg,.jpeg,.png,.pdf"
        className="hidden"
        onChange={onFileChange}
      />
      <p className="mt-1.5 text-[11px] text-gray-400">Accepted formats: JPG, PNG, PDF</p>
      <p className="text-[11px] text-gray-400">Size Limit: max 10MB</p>
      {uploadError ? <p className="mt-1 text-[11px] text-red-600">{uploadError}</p> : null}
      {uploadedLicenseFileName ? (
        <div className="mt-3 rounded-[10px] border border-green-200 bg-green-50 px-3 py-2">
          <p className="text-[11px] font-semibold uppercase tracking-[0.4px] text-green-700">
            File uploaded
          </p>
          <p className="mt-1 break-all text-sm font-medium text-green-900">
            {uploadedLicenseFileName}
          </p>
        </div>
      ) : null}
    </div>
  )
}
